<app-form-input 
[parentForm]="parentForm" 
[label]="step7.getspan7"
[type]="'radio'"
[disabled]="disabled"
[rule]="'pattern_29'"
[value]="radioButtonValue"
[name]="radioButtonCtrlName"
[radios]="[
						{
                            value: region,
							label: step7.getregion
						},
                        {
                            value: departement,
							label: step7.getdepartement
						},
                        {
                            value: etat,
							label: step7.getetat
						},
                        {
                            value: debiteurEtranger,
							label: step7.getdebiteuretranger
						},
                        {
                            value: autresOrganismesPublics,
							label: step7.getautresorganismespublics
						},
                        {
                            value: debiteurPrivePersPhysique,
							label: step7.getdebiteurprivepersphysique
						},
                        {
                            value: groupementCollectivites,
							label: step7.getgroupementcollectivites
						},
                        {
                            value: commune,
							label: step7.getcommune
						},
                        {
                            value: debiteurPrivePersMorale,
							label: step7.getdebiteurprivepersmorale
						},
                        {
                            value: etablissementsPublicsSante,
							label: step7.getetablissementspublicssante
						},
    ]"
>
</app-form-input>
